import angular from 'angular'
import storyTags from './storyTags.component'

export default angular
  .module('ellipsis.storyTags', [])
  .component('storyTags', storyTags)
